import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './src/context/AppContext';
import { Layout } from './src/components/Layout';
import { Home } from './src/pages/Home';
import { Catalog } from './src/pages/Catalog';
import { ProductDetail } from './src/pages/ProductDetail';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            <Route index element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="shop" element={<Catalog data-id="element-8" />} data-id="element-7" />
            <Route path="product/:id" element={<ProductDetail data-id="element-10" />} data-id="element-9" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}